const BUILT_IN_FILTER_KEYS = ['category', 'gender'];

export function configuredResultFilters(resultsConfig = {}) {
  return Array.isArray(resultsConfig.filters)
    ? resultsConfig.filters
    : BUILT_IN_FILTER_KEYS.map((key) => ({ key }));
}

export function initialAdditionalFilterValues(definitions = [], selected = {}) {
  return definitions
    .filter((definition) => !BUILT_IN_FILTER_KEYS.includes(definition.key))
    .reduce((values, definition) => ({
      ...values,
      [definition.key]: selected[definition.key] ?? ''
    }), {});
}

export function initialNameSearch(query = {}) {
  const exactValue = query.name_or_bib_eq;
  const exact = exactValue != null && exactValue !== '';

  return {
    exact,
    value: exact ? exactValue : (query.name_or_bib_start ?? null)
  };
}

export function availableAdditionalFilters(definitions = [], options = {}) {
  return definitions.filter((definition) => (
    !BUILT_IN_FILTER_KEYS.includes(definition.key) &&
    Array.isArray(options[definition.key]) &&
    options[definition.key].length > 0
  ));
}

export function selectedAdditionalFilters(values = {}) {
  return Object.entries(values).reduce((selected, [key, value]) => {
    if (value != null && value !== '') selected[key] = value;
    return selected;
  }, {});
}

export function filteredSelectionRowNumber(rowIndex, pageInfo = {}) {
  const currentPage = Math.max(Number(pageInfo.currentPage) || 1, 1);
  const perPage = Math.max(Number(pageInfo.perPage) || 0, 0);
  const index = Math.max(Number(rowIndex) || 0, 0);

  return ((currentPage - 1) * perPage) + index + 1;
}

export function filteredSelectionField(label) {
  return {
    key: 'filtered_index',
    label,
    class: 'text-center results-filtered-index'
  };
}

export function sortedFilterValues(values = [], locale) {
  const collator = new Intl.Collator(locale, {
    sensitivity: 'base',
    numeric: true,
    ignorePunctuation: true
  });

  return values.slice().sort((left, right) => collator.compare(String(left), String(right)));
}

export function additionalFilterSelectOptions(definition, values = [], locale) {
  return [
    { value: '', text: `— ${definition.label} —` },
    ...sortedFilterValues(values, locale).map((value) => ({ value, text: value }))
  ];
}
